import React, { FC } from "react";
import "./ToggleButton.scss";

interface IToggleButtonProps {
    id: string;
    checked: boolean;
    onChange: (checked: boolean) => void;
    labelA?: string;
    labelB?: string;
    style?: React.CSSProperties;
}

const ToggleButton: FC<IToggleButtonProps> = ({
    id,
    checked,
    onChange,
    labelA,
    labelB,
    style,
}) => {
    const handleClick = () => {
        onChange(!checked);
    };

    return (
        <button
            id={id}
            onClick={handleClick}
            type="button"
            className="btn btn-outline-dark mr-2"
            style={style}
        >
            {checked ? labelA : labelB}
        </button>
    );
};

export default ToggleButton;
